import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DASHBOARD } from '../../constant';

export const getDashboardData = createAsyncThunk(
  'hospitalTemplate/get',
  async (
    {
      year,
      loggedinEmail,
      studyYear,
      studyMonth,
    }: {
      year: number;
      loggedinEmail: string;
      studyYear: any;
      studyMonth: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };

      const url = `${DASHBOARD.GET_DASHBOARD_DATA}?year=${year}&loggedinEmail=${loggedinEmail}&studyYear=${studyYear}&studyMonth=${studyMonth}`;
      const res = await fetch(url, requestOptions);

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to fetch hospital template');
      }

      const data = await res.json();
      console.log('data', data);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
